const _ = require("lodash");

module.exports = function normalizeContentfulModel(obj, index, key) {
  if (obj && obj.slices) {
    _.map(obj.slices, normalizeContentfulModel);

    const hasValidKeys = _.map(obj.slices, "key").every(Boolean);
    if (hasValidKeys) {
      obj.slices = _.keyBy(obj.slices, "key");
    }

    obj.slices = _.mapValues(obj.slices, (value, key) => {
      if (value === null) return value;
      if (value.hasOwnProperty("value")) return value.value;
      if (value.slices) return value.slices;
      if (value.content) return value.content;
      return value;
    });
  }
  return obj;
};
